
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { useTranslation } from "react-i18next";
import { Edit, Trash2 } from "lucide-react";

interface Course {
  id: string;
  name: string;
  description: string;
  category_id: string;
  default_capacity: number;
  default_duration: number;
}

interface CoursesListProps {
  courses: Course[];
  onEdit: (course: Course) => void;
  onDelete: (courseId: string) => void;
}

export const CoursesList = ({ courses, onEdit, onDelete }: CoursesListProps) => {
  const { t } = useTranslation(['courses']);

  return (
    <div className="space-y-4">
      {courses.map((course) => (
        <Card key={course.id}>
          <CardContent className="p-4 flex justify-between items-start">
            <div className="space-y-1">
              <h3 className="font-medium">{course.name}</h3>
              <p className="text-sm text-muted-foreground">{course.description}</p>
              <div className="text-sm text-muted-foreground">
                <span>{t('capacity')}: {course.default_capacity}</span>
                <span className="mx-2">•</span>
                <span>{t('duration')}: {course.default_duration} min</span>
              </div>
            </div>
            <div className="flex gap-2">
              <Button
                variant="ghost"
                size="icon"
                onClick={() => onEdit(course)}
              >
                <Edit className="h-4 w-4" />
              </Button>
              <Button
                variant="ghost"
                size="icon"
                onClick={() => onDelete(course.id)}
              >
                <Trash2 className="h-4 w-4" />
              </Button>
            </div>
          </CardContent>
        </Card>
      ))}
    </div>
  );
};
